"use client"
/* */
import { jsx } from 'react/jsx-runtime';
import { Wrap } from '../../components/Wrap/Wrap.mjs';
import { useMemo } from 'react';
import '@mittwald/react-tunnel';
import '../slotContext/slotContext.mjs';
import '@react-aria/utils';
import { useContextProps, propsContext } from './propsContext.mjs';
import 'remeda';
import { mergePropsContext } from './mergePropsContext.mjs';
import { ClearPropsContext } from '../../components/ClearPropsContext/ClearPropsContext.mjs';
import '../viewComponentContext/viewComponentContext.mjs';

const PropsContextProvider = (props) => {
  const {
    props: providedProps,
    dependencies = [],
    mergeInParentContext = false,
    children
  } = props;
  const parentPropsContext = useContextProps();
  const memoizedProps = useMemo(() => providedProps, dependencies);
  const propsWithParentPropsContext = useMemo(
    () => mergeInParentContext ? mergePropsContext(parentPropsContext, providedProps) : providedProps,
    [memoizedProps, parentPropsContext, mergeInParentContext]
  );
  return /* @__PURE__ */ jsx(Wrap, { if: !mergeInParentContext, children: /* @__PURE__ */ jsx(ClearPropsContext, { children: /* @__PURE__ */ jsx(propsContext.Provider, { value: propsWithParentPropsContext, children }) }) });
};

export { PropsContextProvider, PropsContextProvider as default };
//# sourceMappingURL=PropsContextProvider.mjs.map
